import {
    takeLatest,
    put,
    call,
    select,
    fork,
    take,
    cancel,
    actionChannel,
    delay,
} from 'redux-saga/effects';
import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { verifyOtp, requestOtp } from 'yoda-interfaces/lib/Account/AccountApi';
import { serviceErrorToAnalyticsFormat } from 'yoda-account-components/lib/analytics/DigitalAnalyticsHelper';
import {
    POST_REQUEST_OTP,
    POST_REQUEST_OTP_SUCCESS,
    POST_REQUEST_OTP_ERROR,
    POST_VERIFY_OTP,
    POST_VERIFY_OTP_SUCCESS,
    POST_VERIFY_OTP_ERROR,
    STOP_OTP_REQUEST,
    ENABLE_RESEND_OTP,
    PHONE_VERIFY_CLEAR_CALLBACKS,
} from '../actionTypes/PhoneVerificationActionTypes';
import FactorySaga from './FactorySaga';
import AnalyticsActionTypes from '../actionTypes/AnalyticsActionTypes';

export const selectPhoneVerification = (state) => state.phoneVerification;

const defaults = {
    context: {},
    phoneVerificationPreferences: {},
};

const selectContext = (state) => state.context || defaults.context;

export const selectPhoneVerificationPreferences = createSelector([selectContext], (context) =>
    get(context, 'preferences.phoneVerification', defaults.phoneVerificationPreferences)
);

function* enableAferDelay() {
    try {
        // get time from config
        const preferneces = yield select(selectPhoneVerificationPreferences);
        const parsedNumber = Number(preferneces.resendEnableTime);
        const DELAY = parsedNumber || 5000;
        yield delay(DELAY);
        yield put({ type: ENABLE_RESEND_OTP });
    } catch (err) {
        console.error('some error occured:', err);
    }
}

function* delayedEnableResendTask() {
    try {
        const bgTask = yield fork(enableAferDelay);

        const requestChan = yield actionChannel([
            POST_REQUEST_OTP_ERROR,
            POST_VERIFY_OTP,
            POST_VERIFY_OTP_SUCCESS,
            STOP_OTP_REQUEST,
        ]);
        while (true) {
            // NOSONAR
            // wait for any actions to trigger
            // or delay to complete
            yield take(requestChan);
            yield cancel(bgTask);
            yield put({ type: ENABLE_RESEND_OTP });
            // break;
        }
    } catch (err) {
        console.error('some error occured:', err);
    }
}
export function* requestOTPSaga(action) {
    try {
        const phoneNumber = get(action, 'payload.phoneNumber');
        if (!phoneNumber) {
            yield put({ type: POST_REQUEST_OTP_ERROR });
            return;
        }
        const response = yield call(FactorySaga, requestOtp, action);
        if (response.isSuccess) {
            const isReSendRequest = get(action, 'payload.isReSendRequest');
            yield put({
                type: POST_REQUEST_OTP_SUCCESS,
                payload: { phoneNumber, isReSendRequest },
            });

            yield fork(delayedEnableResendTask);
        } else {
            let error = get(response, 'response.data', {});
            if (isEmpty(error)) {
                error = {
                    errorCode: 'PHONE_VERIFICATION_DEFAULT_EXCEPTION',
                };
            }
            yield put({
                type: POST_REQUEST_OTP_ERROR,
                payload: error,
                isLandlineError: error.errorCode === 'SRV_NOT_MOBILE',
            });
        }
    } catch (error) {
        const err = {
            errorMessage: error.message,
            errorCode: 'PHONE_VERIFICATION_DEFAULT_EXCEPTION',
        };
        yield put({ type: POST_REQUEST_OTP_ERROR, error: err, isLandlineError: false });
    }
}
export function* cbOnVerificationSuccess() {
    // this call back will be executed on
    // verification process

    const phoneVerificationRedux = yield select(selectPhoneVerification);
    const callback = phoneVerificationRedux.onPhoneVerificationSuccess;
    if (typeof callback === 'function') {
        yield* callback();
        yield put({ type: PHONE_VERIFY_CLEAR_CALLBACKS });
    }
}

export function* cbOnVerificationStop() {
    // this call back will be executed on
    // either when user suspends or acknowledge verification process

    const phoneVerificationRedux = yield select(selectPhoneVerification);
    const callback = phoneVerificationRedux.onPhoneVerificationStop;

    if (typeof callback === 'function') {
        yield* callback();
        yield put({ type: PHONE_VERIFY_CLEAR_CALLBACKS });
    }
}

export function* verifyOTPSaga(action) {
    try {
        const phoneNumber = get(action, 'payload.phoneNumber');
        if (!phoneNumber) {
            yield put({ type: POST_REQUEST_OTP_ERROR });
            return;
        }
        const response = yield call(FactorySaga, verifyOtp, action);
        if (response.isSuccess) {
            yield put({ type: POST_VERIFY_OTP_SUCCESS, payload: response });
            // yield fork(cbOnVerificationSuccess);
        } else {
            yield put({ type: POST_VERIFY_OTP_ERROR, payload: get(response, 'response.data', {}) });
        }
    } catch (error) {
        // Ameya todo add a generic error message
        yield put({ type: POST_VERIFY_OTP_ERROR });
    }
}

export function* trackFormErrorOnError(action) {
    // converting to payload what Common Middleware Form Error needs
    const errorDetails = serviceErrorToAnalyticsFormat(action.payload);
    yield put({ type: AnalyticsActionTypes.FORM_ERROR, errorDetails });
}

function* watchPhoneVerificationSaga() {
    yield takeLatest(POST_REQUEST_OTP, requestOTPSaga);
    yield takeLatest(POST_VERIFY_OTP, verifyOTPSaga);
    yield takeLatest(STOP_OTP_REQUEST, cbOnVerificationStop);
    yield takeLatest(POST_VERIFY_OTP_ERROR, trackFormErrorOnError);
    yield takeLatest(POST_REQUEST_OTP_ERROR, trackFormErrorOnError);
}
watchPhoneVerificationSaga.sagaName = 'watchPhoneVerification';
export default watchPhoneVerificationSaga;
